import { ScaleTypes } from '../discharge-store';

export const getWaterPump = (rootStore, runningData) => {
  const { materialStore, devicesStore } = rootStore;

  if (runningData?.mixDesign?.length) {
    const water = runningData.mixDesign
      .find(v => materialStore.isWater(v.constituentItemId) && v.quantityBatchSize > 0);
    const material = water
      ? materialStore.materials
        .find(v => v.itemId === water.constituentItemId)
      : null;

    return material ? devicesStore.pumps.find(v => v.id === material.pumpId) : null;
  }

  return null;
};

export const getSecondWaterPump = (rootStore, runningData) => {
  const { materialStore, devicesStore } = rootStore;

  if (runningData?.mixDesign?.length) {
    const water = runningData.mixDesign
      .find(v => materialStore.isSecondWater(v.constituentItemId) && v.quantityBatchSize > 0);
    const material = water
      ? materialStore.materials
        .find(v => v.itemId === water.constituentItemId)
      : null;

    return material ? devicesStore.pumps.find(v => v.id === material.pumpId) : null;
  }

  return null;
};

export const isHeadWaterNotDischarged = (rootStore, runningData) => {
  const waterPump = getWaterPump(rootStore, runningData);
  const secondWaterPump = getSecondWaterPump(rootStore, runningData);

  // Check for metered water (water pumps)
  const pumpHeadWaterNotDischarged = runningData.headWater > 0
    && (
      (
        (waterPump?.tankId || secondWaterPump?.tankId)
        && !runningData.headWaterTankDischarged
      ) || (
        (waterPump || secondWaterPump)
        && !runningData.headWaterPumpDischarged
      )
    );

  const waterScale = runningData?.sequence?.discharges?.find(v => v.type === ScaleTypes.WATER);
  const scaleHeadWaterNotDischarged = runningData.headWater > 0
    && waterScale
    && !runningData.headWaterScaleDischarged;

  return pumpHeadWaterNotDischarged || scaleHeadWaterNotDischarged;
};
